import { create } from 'zustand';

interface UIState {
  sidebarOpen: boolean;
  theme: 'light' | 'dark';
  
  // Actions
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setTheme: (theme: 'light' | 'dark') => void;
  toggleTheme: () => void;
}

// Expanded on desktop, off-canvas (closed) on mobile so the drawer never
// covers content on first load. Falls back to open when there's no window.
const getDefaultSidebarOpen = () =>
  typeof window !== 'undefined' ? window.innerWidth >= 1024 : true;

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: getDefaultSidebarOpen(),
  theme: 'light',

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setTheme: (theme) => set({ theme }),
  toggleTheme: () =>
    set((state) => ({ theme: state.theme === 'light' ? 'dark' : 'light' })),
}));
